import React from 'react';

function Footer() {
  return (
    <footer style={{ backgroundColor: 'var(--primary-green)', color: 'var(--text-light)', padding: '1.5rem 2rem', marginTop: '2rem' }}>
      <div className="footer-content" style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center' }}>
        
        <div style={{ flex: '1 1 300px', marginBottom: '1rem' }}>
          <h3 style={{ marginBottom: '0.5rem' }}>Foodies Delight</h3>
          <p>Delivering fresh, delicious meals right to your door. Quality ingredients & authentic flavors guaranteed.</p>
        </div>

        <div style={{ flex: '1 1 200px', marginBottom: '1rem' }}>
          <h4>Contact Us</h4>
          <p>Phone: <a href="tel:+918709391155" style={{ color: 'var(--text-light)', textDecoration: 'none' }}>8709 391 155</a></p>
          <p>Email: <a href="mailto:mohaimin07@gmail.com" style={{ color: 'var(--text-light)', textDecoration: 'none' }}>mohaimin07@gmail.com</a></p>
        </div>

        <div style={{ flex: '1 1 200px', marginBottom: '1rem' }}>
          <h4>Follow Us</h4>
          <ul style={{ listStyle: 'none', display: 'flex', gap: '1rem', padding: 0, margin: 0 }}>
            <li><a href="#" aria-label="Facebook" style={{ color: 'var(--text-light)' }}>Facebook</a></li>
            <li><a href="#" aria-label="Instagram" style={{ color: 'var(--text-light)' }}>Instagram</a></li>
            <li><a href="#" aria-label="Twitter" style={{ color: 'var(--text-light)' }}>Twitter</a></li>
            <li><a href="#" aria-label="Twitter" style={{ color: 'var(--text-light)' }}>whatsapp</a></li>
          </ul>

        </div>

      </div>
      <div style={{ textAlign: 'center', marginTop: '1rem', fontSize: '0.9rem', opacity: 0.8 }}>
        © 2023 Foodies Delight. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;

